export default "__VITE_ASSET__CBqNvvGE__"